import { Card, CardActionArea, CardActions, CardContent, Typography, IconButton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { KnowledgeBaseCollection } from '@/core/models/knowledge-base-collection.model';
import { Delete as DeleteIcon } from '@mui/icons-material';

type CollectionCardProps = {
    collection: KnowledgeBaseCollection;
    onDelete: (collection: KnowledgeBaseCollection) => void;
    isDeleting: boolean;
};

function CollectionCard({ collection, onDelete, isDeleting }: CollectionCardProps) {
    const handleDelete = () => {
        onDelete(collection);
    };

    return (
        <Card>
            <CardActionArea component={RouterLink} to={`/admin/knowledge-base/${collection._id}`}>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {collection.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {collection.description || 'No description provided.'}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
                <IconButton onClick={handleDelete} disabled={isDeleting} size="small" color="error">
                    <DeleteIcon />
                </IconButton>
            </CardActions>
        </Card>
    );
}

export default CollectionCard; 